import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const CustomCardsSkeleton = ({ browser, isProviderDetail }) => {
  // Number of skeleton cards to display
  const cardCount = 6;

  return (
    <div className="w-full flex flex-wrap justify-center lg:justify-start ">
      {Array.from({ length: cardCount }).map((_, index) => (
        <div
          key={index}
          className={`${
            isProviderDetail
              ? "lg:w-96 custom-breakpoint-3:w-72 custom-breakpoint-4:w-72"
              : "w-72 "
          }  rounded-2xl bg-white border h-80 mb-4 ${
            browser === "edge"
              ? "ml-0 md:ml-[1.3rem]"
              : isProviderDetail
              ? index === 0 || index === 3
                ? "ml-0"
                : "ml-3"
              : "ml-0 md:ml-[1.85rem]"
          }  h-80 mb-8`}
        >
          <div
            className={`flex ${
              isProviderDetail ? "justify-start px-4" : "justify-center"
            } items-center mt-2`}
          >
            <Skeleton width={260} height={80} />
          </div>
          <div className="px-4 py-3 flex flex-col gap-y-5">
            <div className="flex justify-between items-center gap-x-12">
              <dt className="text-sm font-semibold text-custom-dark-grey">
                <Skeleton width={150} height={30} />
              </dt>
            </div>
            <div className="flex justify-between items-center gap-x-12 text-custom-light-grey">
              <dt className="text-basic font-semibold text-custom-dark-grey">
                <Skeleton width={250} height={60} />
              </dt>
            </div>
            <div className="flex justify-between items-center gap-x-12 text-custom-light-grey">
              <dt className="text-basic font-semibold text-custom-dark-grey">
                <Skeleton width={250} height={30} />
              </dt>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default CustomCardsSkeleton;
